import type { StackProps } from '@mui/material';
import {
  Card,
  CircularProgress,
  Stack,
  styled,
  Tooltip,
  Typography,
} from '@mui/material';
import type { FC } from 'react';
import React from 'react';
import { useFormatting } from '@pflegenavi/frontend/localization';
import { Iconify } from '@pflegenavi/web-components';

// ----------------------------------------------------------------------

interface Props extends StackProps {
  title: string;
  total: number;
  percent: number;
  amount: number;
  color?: string;
  icon: string;
  tooltipText?: string;
}

export const StripeStateCard: FC<Props> = ({
  title,
  total,
  color,
  percent,
  amount,
  icon,
  tooltipText,
  ...props
}) => {
  const { fCurrencyCents } = useFormatting();
  return (
    <Tooltip title={tooltipText} placement="bottom" arrow>
      <CardContainer {...props}>
        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Stack
            sx={{
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
            }}
          >
            <Iconify
              color={color}
              width={25}
              height={25}
              icon={icon}
              sx={{ position: 'absolute' }}
            />

            <CircularProgress
              variant="determinate"
              value={percent}
              size={56}
              thickness={4}
              sx={{
                color,
                opacity: 0.48,
              }}
            />

            <CircularProgress
              variant="determinate"
              value={100}
              size={56}
              thickness={4}
              sx={{
                color: 'grey.50016',
                position: 'absolute',
                top: 0,
                left: 0,
                opacity: 0.48,
              }}
            />
          </Stack>

          <Stack sx={{ ml: 2 }}>
            <Typography variant="h6">{title}</Typography>
            <Typography variant="subtitle2" sx={{ color }}>
              {fCurrencyCents(amount)}
            </Typography>
          </Stack>
        </Stack>
      </CardContainer>
    </Tooltip>
  );
};

const CardContainer = styled(Card)(({ theme }) =>
  theme.unstable_sx({
    width: 1,
    minWidth: 200,
    padding: {
      xs: 2,
    },
  })
);
